import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from './Request';

export interface ISetSiteSAMLAllowEmbeddedAuthenticationParams {
  allow: boolean;
}

export class SetSiteSAMLAllowEmbeddedAuthenticationRequest extends Request<ISetSiteSAMLAllowEmbeddedAuthenticationParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteSAMLAllowEmbeddedAuthenticationParams) {
    super('setSiteSAMLAllowEmbeddedAuthentication', params);
  }
}
